import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { IShouldObserveHeaderHandler } from '../types'
import { name } from '../symbols'

export const ShouldObserveHeaderHandler = withDependencies(
	[named(EditorFeatureConfigSymbol, name)],
	(editorConfig): IShouldObserveHeaderHandler => {
		return {
			shouldObserveHeader: !editorConfig.isEditMode && editorConfig.shouldObserveHeader,
		}
	}
)
